"use client";
import { useModalDispatch } from "@/context/ModalContext";
import { getGlobalStateValue } from "@/context/utils";
import { pushToDataLayer } from "@/helpers/gtag";
import useOnScreen from "@/helpers/Onscreen";
import { IModalActions, ModalTypes } from "@/types/modal";
import React, { useEffect, useRef, useState } from "react";
import styles from './CertCard.module.scss';
import { usePathname } from "next/navigation";
import { useIpStackDetails } from "@/helpers/useIpStackDetails";

export default function ClientButton({ associatedPrograms, jioPc_details, ...rest }) {
  const path = usePathname();
	const isAfricaPage = path == "/africa";
  const {ipStackDetails,countryCode} = useIpStackDetails(isAfricaPage);  

  const modalDispatch = useModalDispatch();
  const ref = useRef(null);
  const [ countryDetails, setCountryDetails ] = useState({
    countryCode:"", 
    countryName:""
  })
  const onScreen = useOnScreen(ref);

  const fetchCountryCode = async (data) => {
    setCountryDetails(data);
    localStorage.setItem("countryDetails", JSON.stringify(data));
  };

  useEffect(() => {
    fetchCountryCode({
      countryCode: ipStackDetails?.country_code,
      countryName: ipStackDetails?.country_name,
    });
  }, [ipStackDetails]);

  useEffect(() => {
    const enrollNowRef = document.getElementById("enroll-now-cta");

    if (enrollNowRef) {
      if (onScreen) {
        enrollNowRef.classList.remove(styles.dislayEnrollNow);
        enrollNowRef.classList.add(styles.hideEnrollNow);
       
      } else {

        enrollNowRef.classList.add(styles.dislayEnrollNow);
        enrollNowRef.classList.remove(styles.hideEnrollNow);

      }
    }
  }, [onScreen]);

  const openRFIForm = () => {
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.ConnectModalFormSponsoredCourses,
        modalData: { 
          associatedPrograms, 
          CTAName: "ENROLL NOW", 
          countryDetails,
          jioPc_details
        },
      },
    });

    setTimeout(() => {
      pushToDataLayer({
        event: "lead_initiate",
        cta_text: "Enroll Now",
        section_name: "Right section",
        page_type: getGlobalStateValue("pageType"),
        page_url: location.href,
      });
    }, 2500);
  };

  return (
    <button {...rest} ref={ref} onClick={openRFIForm}>
      Enroll Now
    </button>
  );
}
